import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const ToastMessageTDAs = gql`
    query ToastMessageTDAs ($id: ID!) {
        toastMessage (id: $id) {
            id
            message
            fromDate
            toDate
            status
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
